import React, { useState, useEffect } from 'react';
import { Box, Typography, Snackbar, Alert } from '@mui/material';
import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import rightIcon from '../../assets/images/ic_right.png';
import on1Icon from '../../assets/images/check/on1.png';
import off1Icon from '../../assets/images/check/off1.png';
import { settingAPI } from '../../actions/imsServer';
import CustomButton from '../../components/button';

export const Language = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();  
  const [tempSelectedLanguage, setTempSelectedLanguage] = useState(i18n.language || 'en');
  const [settingExists, setSettingExists] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const hospitalId = JSON.parse(localStorage.getItem('meInfo'))?.hospitalId;
  const type = useLocation().state?.type || 'auth';

  useEffect(() => {
    const fetchSetting = async () => {
      try {

        if(localStorage.getItem('meInfo')) {
          const settingResponse = await settingAPI.getSettings({
            userId: JSON.parse(localStorage.getItem('meInfo'))?.id,
            name: 'language'          
          });
          const settings = settingResponse.data?.settings || [];
          
          if (settings.length > 0) {
            setSettingExists(true);                 
            await i18n.changeLanguage(settings[0].value);
            localStorage.setItem('language', settings[0].value);
          }
        }
      } catch (error) {
        console.error('Error fetching language setting:', error);
      }
    };
    fetchSetting();
  }, [hospitalId, i18n]);

  const handleLanguageClick = async (code) => {
    setTempSelectedLanguage(code);
  };

  const handleChangeLanguage = async () => {
    try {
      await i18n.changeLanguage(tempSelectedLanguage);
      localStorage.setItem('language', tempSelectedLanguage);      

      if(localStorage.getItem('meInfo')) {
        if (settingExists) {
          await settingAPI.updateSetting({          
            name: 'language',
            value: tempSelectedLanguage,
          });
          setSettingExists(true);
        } else {
          await settingAPI.registerSetting({         
            name: 'language',
            value: tempSelectedLanguage,
          });
          setSettingExists(true);
        }
      }
      
      // 스낵바 메시지 설정 및 표시
      setSnackbarMessage(t('commander_edit_save_success'));
      setSnackbarOpen(true);
      
      // 1초 후 뒤로가기
      setTimeout(() => {
        navigate(-1);
      }, 1000);
      
    } catch (error) {
      console.error('Error changing language:', error);
      setSnackbarMessage(t('medication_setting_save_error'));
      setSnackbarOpen(true);
    }
  };

  const languages = [
    { code: 'ko', name: 'Korean', nativeName: '한국어' },
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'ja', name: 'Japanese', nativeName: '日本語' }
  ];

  return (
    <Box
      sx={{
        display: 'flex', 
        width: {xs: 'calc(100% + 32px)', sm: 'calc(100% + 24px)', md: '100%'},
        minHeight: '100vh',
        margin: 0,
        marginLeft: {xs: '-17px', sm: '-15px', md: 0},
        mt: type === 'setting' ? '-20px' : '0px',
        pt: 0,
        flexDirection: 'column',
        alignItems: {md: 'flex-start'},
        flex: '1 0 0', 
        alignSelf: 'stretch'
      }}
    >
      <Box sx={{
        display: {xs: 'none', md: 'flex'},
        width: '1368px',
        height: '50px',
        padding: '20px 32px 10px 32px',
        flexDirection: 'column',
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          alignSelf: 'stretch'
        }}>           
          <Typography variant="h5" sx={{ color: '#211F20', fontSize: 15, fontWeight: 700, lineHeight: '20px' }}>{t('setting_language_change')}</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          width: { xs: '100%', md: 420 },
          //height: '100vh',
          bgcolor: '#FFF',
          borderRadius: { xs: 0, md: 3 },
          boxShadow: { xs: 'none', md: 3 },
          mx: { xs: 0, md: 0 },
          ml: { xs: 0, md: '32px' },
          mr: { xs: 0, md: 'auto' },
          alignSelf: { xs: 'stretch', md: 'flex-start' },
          display: 'flex',
          flexDirection: 'column',
         
        }}
      >
        {/* Title Bar */}
        <Box
          sx={{
            display: {xs: 'flex', md: 'none'},
            alignItems: 'center',
            height: { xs: '54px', md: '64px' },
            px: { xs: 2, md: 3 },
            borderBottom: '1px solid rgba(0,0,0,0.10)',
            background: type === 'auth' ? "transparent" : "#F5F3F6",
            borderTopLeftRadius: { xs: 0, md: 12 },
            borderTopRightRadius: { xs: 0, md: 12 },
          }}
        >
          <Box
            component="img"
            src={rightIcon}
            alt="right"
            sx={{ width: 20, height: 20, mr: 1, cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: { xs: '15px', md: '18px' },
              color: '#211F20',
              }}
          >
            {t('setting_language_change')}
          </Typography>
        </Box>
        
        {/* Language List - Scrollable Area */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            overflow: 'auto',   
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              px: { xs: 2, md: 3 },
              pt: { xs: 0, md: 2 },
              pb: { xs: 0, md: 2 },
            }}
          >
            {languages.map((lang, idx) => (
              <Box
                key={lang.code}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: { xs: '60px', md: '64px' },
                  minWidth: '280px',
                  justifyContent: 'space-between',
                  alignSelf: 'stretch',
                  borderBottom:
                    idx !== languages.length - 1
                      ? '1px solid rgba(0, 0, 0, 0.10)'
                      : 'none',
                  cursor: 'pointer',
                  pl: 2,
                  pr: 2,
                  transition: 'background 0.2s',
                  '&:hover': {
                    background: { xs: 'none', md: '#f5f5f5' },
                  },
                }}
                onClick={() => handleLanguageClick(lang.code)}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    flex: '1 0 0',
                  }}
                >
                  <Typography
                    sx={{
                      color: 'rgba(0, 0, 0, 0.60)',
                            fontSize: { xs: '15px', md: '16px' },
                      fontWeight: '500',
                    }}
                  >
                    {lang.nativeName}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#aaa',
                            fontSize: { xs: '13px', md: '14px' },
                      fontWeight: '400',
                    }}
                  >
                    ({lang.name})
                  </Typography>
                </Box>
                <Box
                  component="img"
                  src={tempSelectedLanguage === lang.code ? on1Icon : off1Icon}
                  alt={tempSelectedLanguage === lang.code ? 'on' : 'off'}
                  sx={{ height: '20px', width: '20px', ml: 1 }}
                />
              </Box>
            ))}
          </Box>
        </Box>

        {/* Save Button - Fixed at Bottom */}
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            gap: 2, 
            mt: 4,
            width: { xs: 'calc(100% - 40px)', md: 'calc(100% - 64px)' },
            position: 'fixed',
            bottom: {xs: 100, md: type === 'auth' ? 40 : 20},
            left: { xs: 20, md: 'auto' },
            right: { xs: 20, md: 'auto' },
            ml: { xs: 0, md: '32px' },
            mr: { xs: 0, md: 'auto' },
            maxWidth: { md: 420 },
            padding: '10px',
            borderRadius: '8px',
            zIndex: 1000,                     
          }}
        >
          <CustomButton
            onClick={handleChangeLanguage}
          >
            {t('common_save')}
          </CustomButton>
        </Box>
      </Box>
      
      {/* Snackbar for language change notification */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{
          // AOS 웹뷰에서 상단에 안전하게 표시되도록 여백 조정
          mt: { xs: '60px', sm: '20px' }
        }}
      >
        <Alert 
          onClose={() => setSnackbarOpen(false)} 
          severity="success" 
          sx={{ 
            width: '100%',
            // AOS 웹뷰에서 더 잘 보이도록 스타일 강화
            fontSize: '14px',
            fontWeight: 500,
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)'
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};
